import React from 'react';

const AnswerActionContext = React.createContext([]);

export default AnswerActionContext;
